import aiAssistantCardFooters from '../../consts/aiAssistant/aiAssistantCardFooters';
import aiAssistantPresentations from '../../consts/aiAssistant/aiAssistantPresentations';
import aiAssistantProposalStatuses from '../../consts/aiAssistant/aiAssistantProposalStatuses';
import aiAssistantStates from '../../consts/aiAssistant/aiAssistantStates';

const getIsCardShown = (proposal) => proposal?.presentation === aiAssistantPresentations.PANEL;

// Follows the backend's WAITING, not the proposal: the line appears once the question has been spoken
const getCardFooter = (assistantState, proposal) => {
    if (proposal?.status === aiAssistantProposalStatuses.APPLIED) return aiAssistantCardFooters.PROGRESS;

    if (assistantState === aiAssistantStates.WAITING) return aiAssistantCardFooters.CONFIRMATION;

    return aiAssistantCardFooters.NONE;
};

// Current value until confirmed, then proposed, then applied; back to current if the write failed
const getProposalSettingValue = (proposal, settingName) => {
    const {settings, status, confirmedSettingName, appliedValue} = proposal;
    const {currentValue, proposedValue} = settings.find((setting) => setting.settingName === settingName);

    // Candidates the user didn't pick keep their value
    if (confirmedSettingName && confirmedSettingName !== settingName) return currentValue;

    if (status === aiAssistantProposalStatuses.APPLIED) return appliedValue ?? proposedValue;

    if (status === aiAssistantProposalStatuses.APPLYING) return proposedValue;

    return currentValue;
};

export default {getIsCardShown, getCardFooter, getProposalSettingValue};
